import React from 'react';
import { browserHistory } from 'react-router';
import GlobalHeader from '../../Fragments/GlobalHeader';
import MyHomeLetRegistration from '../../Fragments/MyHomeLetRegistration';

let Quote = require('../../Managers/Quote');
let Policy = require('../../Managers/Policy');
let ReactGA = require('react-ga');

const PaymentSuccess = React.createClass ({
    getInitialState() {
        let scheduleHardLink = 'https://homeletuk.com/cgi-bin/UserAdmin/docs/dochistory.pl?instruction=dodoc&hash=';
        return {
            scheduleLink: (localStorage.getItem("policy") !== null && Policy.get('policy_doc_request_hash')) ? scheduleHardLink + Policy.get('policy_doc_request_hash') : '/error',
            title: (localStorage.getItem("policy") !== null && Policy.get('title')) ? Policy.get('title') : null,
            lastName: (localStorage.getItem("policy") !== null && Policy.get('lastName')) ? Policy.get('lastName') : null,
            policyNo: (localStorage.getItem("policy") !== null && Policy.get('policy_no')) ? Policy.get('policy_no') : null,
            isLoggedIntoMyhomelet : Quote.getCurrentAnswer('is_logged_into_myhomelet'),
            asn: '1403796',
            quote: Quote.getQuote(),
        };
    },

    componentWillMount() {
        ReactGA.initialize('UA-1926380-5');
    },

    componentDidMount() {
        window.scrollTo(0, 0);
        if (!this.state.policyNo && !Quote.hasQuote()) {
            browserHistory.push('/start');
        } else if (!this.state.policyNo && Quote.hasQuote()) {
            browserHistory.push('/quote');
        } else {
            this.logPayment();
        }
    },

    componentDidUpdate() {
        window.scrollTo(0, 0);
    },

    logPayment() {
        let ipt = (this.state.quote.premiums.annual.formatted.gross_inc_ipt - this.state.quote.premiums.annual.formatted.gross).toFixed(2);
        // Payment successful and production environment
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event':'purchase',
            'transactionId': this.state.policyNo.toString(),
            'transactionAffiliation': this.state.asn.toString(),
            'transactionTotal': this.state.quote.premiums.annual.formatted.gross,
            'transactionTax': ipt,
            'transactionProducts': [{
                'sku': 'landlordsp',
                'name': 'Landlord\'s Insurance',
                'category': this.state.quote.policy_options['raw'].toString(),
                'price': this.state.quote.premiums.annual.formatted.gross,
                'quantity': 1
            }]
        });

        // Push event to GA
        ReactGA.event({
            category: 'Landlord Insurance',
            action: 'Payment Success',
            label: 'Quote Form'
        });
    },

    render() {
        return (
            <div>
                <GlobalHeader />
                <div className="stepless" />
                <question-row class="no-border unpadded">
                    <h2>Welcome to HomeLet, {this.state.title} {this.state.lastName}</h2>
                </question-row>
                <question-row>
                    <div className="question-main">
                        <div className="field-content">
                            <p><b>Your HomeLet policy number is {this.state.policyNo}</b></p>
                            <p>
                                Thank you for choosing HomeLet for your insurance cover. As we mention above your HomeLet policy number is {this.state.policyNo}. Please make sure you have this to hand if you <a href="https://homelet.co.uk/contact-us" className="underline" target="_blank">contact us</a> in the future about your policy.
                            </p>
                        </div>
                        <div className="field-content">
                            <p>Your Policy Schedule and Policy Wording can be viewed below:</p>

                            <ul>
                                <li>
                                    <a className="underline" target="_blank" href={this.state.scheduleLink}>
                                        Your Policy Schedule
                                    </a>
                                </li>
                                <li>
                                    <a className="underline" target="_blank" href="https://homelet.co.uk/downloads/hl-ll-pw">
                                        Your Policy Wording
                                    </a>
                                </li>
                            </ul>

                            <p>
                                It&rsquo;s important that you review your documentation and let us know immediately if anything needs changing, this is to help ensure that you&rsquo;re fully covered should something happen.
                            </p>

                            <h2>Accessing your policy documents</h2>

                            <p>
                                You can access all of your policy documents online using <b>My HomeLet</b>. We&rsquo;ll send you notifications by email to let you know if there are any new documents for you to view online - so you&rsquo;ll never miss a thing.
                            </p>

                            {! this.state.isLoggedIntoMyhomelet ?
                                <MyHomeLetRegistration />
                            : null}

                            <h3>Your rights of cancellation</h3>

                            <p>
                                You have the right to cancel your new policy during the 14 day period after the inception of your policy, which is today.
                            </p>

                            <p>If you do decide to cancel within the 14 day period, you&rsquo;re entitled to a full refund of the premium, unless you have made a claim. For full terms and conditions please refer to your <a className="underline" href="https://homelet.co.uk/downloads/hl-ll-pw" target="_blank">Policy Wording</a>.</p>

                            <h3>Automatic renewal</h3>

                            <p>Your policy will automatically renew at the end of the term; you can change your renewal preference at any time using MyHomeLet or by contacting us on 0800 035 8258.</p>

                            <h3>Let us know if anything changes</h3>

                            <p>
                                Now that you&rsquo;re covered, we&rsquo;d like to remind you that you need to inform us of any change in circumstances that could affect your insurance cover. This is really important, because a failure to disclose information may mean that your policy will not give you the protection you require, or even invalidate your policy altogether. If something does change and you&rsquo;re not sure what to disclose, please don&rsquo;t hesitate to <a href="https://homelet.co.uk/contact-us" className="underline">contact us</a> - we&rsquo;re always happy to help.
                            </p>

                            <h3>So, here&rsquo;s a recap of what you need to do...</h3>

                            <ul>
                                {! this.state.isLoggedIntoMyhomelet ? <li>Check your inbox for your My HomeLet registration email</li> : null}
                                <li>Check your policy documents</li>
                                <li>Relax... we&rsquo;ve got you covered!</li>
                            </ul>

                            <p><b>Welcome to HomeLet!</b></p>
                        </div>
                    </div>
                </question-row>
            </div>
        );
    }
});

export default PaymentSuccess;



/** WEBPACK FOOTER **
 ** ./src/components/Screens/Payment/PaymentSuccess.js
 **/